import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { IncrediSelect } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject, ref, watch } from 'vue';
import { Builds_InitiatorType } from '@/graphql/codegen/generated/graphql';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'initiatorType',
  setup(__props) {

const initiatorTypesLabels: Record<Builds_InitiatorType, string> = {
  [Builds_InitiatorType.Ci]: 'CI',
  [Builds_InitiatorType.Developer]: 'Developer',
  [Builds_InitiatorType.MissingLicense]: 'None',
};
const workloadsPageData = inject(IKWorkloadsPageData);
const mapInitiatorTypeToDisplay = (initiatorType: Builds_InitiatorType[]) => initiatorType?.map((type: Builds_InitiatorType) => initiatorTypesLabels[type]);

const modelValue = ref(workloadsPageData?.filter?.get?.value?.initiatorType as Builds_InitiatorType[]);

const initiatorTypesFiltered = computed(() => {
  const initiatorTypes = Object.keys(initiatorTypesLabels).filter(type => workloadsPageData?.initiatorTypes.value.includes(type as Builds_InitiatorType)) as Builds_InitiatorType[];
  return initiatorTypes.map(key => initiatorTypesLabels[key]);
});

const handleSubmitFilter = () => {
  workloadsPageData?.filter?.setInitiatorType(modelValue.value);
};

const handleUpdateFilter = (selection: []) => {
  modelValue.value = selection.map(type => Object.keys(initiatorTypesLabels).find(key => initiatorTypesLabels[key as Builds_InitiatorType] === type) as Builds_InitiatorType);
  if (modelValue.value.length === 0) {
    handleSubmitFilter();
  }
};

watch(
  () => workloadsPageData?.filter?.get?.value?.initiatorType,
  (newValue: any) => {
    modelValue.value = newValue;
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      (_unref(initiatorTypesFiltered).length > 1)
        ? (_openBlock(), _createBlock(_unref(IncrediSelect), {
            key: 0,
            items: _unref(initiatorTypesFiltered) as any,
            "model-value": mapInitiatorTypeToDisplay(modelValue.value) as any,
            size: "tiny",
            design: "ghost",
            direction: "bottom-sticky-left",
            label: "Initiator type",
            multiple: "",
            clearable: "",
            "list-min-width": 160,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (item) => handleUpdateFilter(item)),
            onSubmit: handleSubmitFilter
          }, null, 8, ["items", "model-value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})